export default {
  methods: {
    validateEmail: function (email) {
      // eslint-disable-next-line max-len
      const reg = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
      reg.lastIndex = 0
      return reg.test(email)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/validateEmail.js